import appStore from 'store';
import api from './api';
const store = {
  namespaced: true,
  state: {
    projects: [],
    coinTypeList: [],
    editingProject: null,
    orderList: {
      0: { value: '未开始', color: 'danger' },
      1: { value: '开售中', color: 'primary' },
      2: { value: '售卖结束', color: 'success' },
      3: { value: '挖矿中', color: 'warning' },
      4: { value: '已结束', color: 'info' }
    }
  },
  getters: {},
  mutations: {
    setList(state, payload) {
      state.projects = payload;
    },
    setCoinTypeList(state, payload) {
      state.coinTypeList = payload;
    },
    setEditingProject(state, payload) {
      state.editingProject = payload;
    }
  },
  actions: {
    getList({ commit }, query) {
      api.getList(query).then(({ data }) => {
        commit('setList', data);
      });
    },
    update(context, data) {
      return api.update(data);
    },
    remove(context, data) {
      return api.remove(data);
    },
    getCoinTypeList({ commit }) {
      api.getCoinTypeList().then(({ data }) => {
        commit('setCoinTypeList', data);
      });
    },
    create(context, data) {
      return api.create(data);
    }
  }
};

appStore.registerModule('mining', store);
